import React from 'react';
import { Box, Button, Container, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Stack
        spacing={3}
        alignItems="center"
        justifyContent="center"
        sx={{
          minHeight: '100vh',
          textAlign: 'center',
          py: 12,
        }}
      >
        <Typography variant="h1" sx={{ color: 'text.disabled' }}>
          404
        </Typography>

        <Typography variant="h3" paragraph>
          {t('errors.404.title')}
        </Typography>

        <Typography sx={{ color: 'text.secondary', maxWidth: 480 }}>
          {t('errors.404.description')}
        </Typography>

        <Box
          component="img"
          alt="404"
          src="/assets/illustrations/illustration_dashboard.png"
          sx={{
            width: 1,
            maxWidth: 320,
            my: { xs: 2.5, md: 5 },
          }}
        />

        <Stack direction="row" spacing={2}>
          <Button
            size="large"
            variant="contained"
            onClick={handleGoHome}
            sx={{
              bgcolor: 'primary.main',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
            }}
          >
            {t('errors.404.goHome')}
          </Button>

          <Button
            size="large"
            variant="outlined"
            onClick={handleGoBack}
            sx={{
              borderColor: 'primary.main',
              color: 'primary.main',
              '&:hover': {
                borderColor: 'primary.dark',
                bgcolor: 'primary.lighter',
              },
            }}
          >
            {t('errors.404.goBack')}
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}
